export enum STATUS {
  EDIT = "edit",
  WAITING = "waiting",
  OPENING = "opening",
  NOWON = "nowon",
  SALE = "sale",
  CLOSED = "closed",
  CANCEL = "cancel",
  RELEASE = "release",
}

export enum ITEM_STATUS {
  RELEASE = "release",
  SOLDOUT = "soldout",
  CANCEL = "cancel",
}

export const STATUS_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAITING]: "公開待ち",
  [STATUS.OPENING]: "公開中",
  [STATUS.NOWON]: "開催中",
  [STATUS.SALE]: "販売中",
  [STATUS.CLOSED]: "販売終了",
  [STATUS.RELEASE]: "公開中",
  [STATUS.CANCEL]: "中止",
};

export const STATUS_INPUT_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAITING]: "公開待ち",
  [STATUS.OPENING]: "公開中",
  [STATUS.NOWON]: "開催中",
  [STATUS.SALE]: "販売中",
  [STATUS.CLOSED]: "販売終了",
  [STATUS.RELEASE]: "公開",
  [STATUS.CANCEL]: "イベント中止",
};
export const ITEM_STATUS_NAME = {
  [ITEM_STATUS.RELEASE]: "販売中",
  [ITEM_STATUS.SOLDOUT]: "成約済",
  [ITEM_STATUS.CANCEL]: "中止",
};

export const STATUS_ARRAY = [
  { id: STATUS.EDIT, name: STATUS_INPUT_NAME[STATUS.EDIT] },
  { id: STATUS.WAITING, name: STATUS_INPUT_NAME[STATUS.WAITING] },
  { id: STATUS.OPENING, name: STATUS_INPUT_NAME[STATUS.OPENING] },
  { id: STATUS.NOWON, name: STATUS_INPUT_NAME[STATUS.NOWON] },
  { id: STATUS.SALE, name: STATUS_INPUT_NAME[STATUS.SALE] },
  { id: STATUS.CLOSED, name: STATUS_INPUT_NAME[STATUS.CLOSED] },
  { id: STATUS.CANCEL, name: STATUS_INPUT_NAME[STATUS.CANCEL] },
];

export const ITEM_STATUS_ARRAY = [
  { id: ITEM_STATUS.RELEASE, name: ITEM_STATUS_NAME[ITEM_STATUS.RELEASE] },
  { id: ITEM_STATUS.SOLDOUT, name: ITEM_STATUS_NAME[ITEM_STATUS.SOLDOUT] },
  { id: ITEM_STATUS.CANCEL, name: ITEM_STATUS_NAME[ITEM_STATUS.CANCEL] },
];

export const STATUS_SELECT_ARRAY = [
  { id: STATUS.EDIT, name: STATUS_NAME[STATUS.EDIT] },
  { id: STATUS.RELEASE, name: STATUS_INPUT_NAME[STATUS.RELEASE] },
  { id: STATUS.CANCEL, name: STATUS_NAME[STATUS.CANCEL] },
];

export const DEFAULT_IMAGE_KEYS = {
  IMAGE_1: 1,
  IMAGE_2: 2,
  IMAGE_3: 3,
  IMAGE_4: 4,
  IMAGE_5: 5,
};

export const DEFAULT_IMAGES = {
  [DEFAULT_IMAGE_KEYS.IMAGE_1]: "event_01.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_2]: "event_02.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_3]: "event_03.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_4]: "event_04.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_5]: "event_05.jpg",
};

export enum GENDER {
    MALE = "male",
    FEMALE = "female",
    UNKNOWN = "unknown",
    FEMALE_NOW = "female_now",
}

export const GENDER_NAME = {
  [GENDER.MALE]: "オス",
  [GENDER.FEMALE]: "メス",
  [GENDER.UNKNOWN]: "不明",
  [GENDER.FEMALE_NOW]: "現在メス",
};

export const GENDER_ARRAY = [
  { id: GENDER.MALE, name: GENDER_NAME[GENDER.MALE] },
  { id: GENDER.FEMALE, name: GENDER_NAME[GENDER.FEMALE] },
  { id: GENDER.UNKNOWN, name: GENDER_NAME[GENDER.UNKNOWN] },
  { id: GENDER.FEMALE_NOW, name: GENDER_NAME[GENDER.FEMALE_NOW] },
];
